export default {"src":"/_next/static/media/twitter-color-icon.280d94d9.svg","height":36,"width":36,"blurWidth":0,"blurHeight":0};